export default [
  {
    path: "/baoming",
    name: "baoming",
    component: (resolve) => require(["pages/mobile/baoming"], resolve),
    meta: {
      showLeftMenu: false,
      showhead: true,
    },
  },
  {
    path: "/",
    redirect: "/baoming",
    meta: {
      showLeftMenu: true,
      showhead: false,
    },
  },
  {
    path: "/login",
    name: "login",
    component: (resolve) => require(["pages/mobile/login"], resolve),
    meta: {
      showLeftMenu: false,
      showhead: false,
    },
  },
  {
    path: "/register",
    name: "register",
    component: (resolve) => require(["pages/mobile/register"], resolve),
    meta: {
      showLeftMenu: false,
      showhead: false,
    },
  },
  {
    path: "/forget",
    name: "forget",
    component: (resolve) => require(["pages/mobile/forget"], resolve),
    meta: {
      showLeftMenu: false,
      showhead: false,
    },
  },

  {
    path: "/mine",
    name: "mine",
    component: (resolve) => require(["pages/mobile/mine"], resolve),
    meta: {
      showLeftMenu: false,
      showhead: false,
    },
  },
  {
    path: "/editpwd",
    name: "editpwd",
    component: (resolve) => require(["pages/mobile/editpwd"], resolve),
    meta: {
      showLeftMenu: false,
      showhead: false,
    },
  },

  { path: "*", redirect: "/baoming" },
];



// WEBPACK FOOTER //
// ./src/router/m.js